import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppTopBar2 from "./common/app-top-bar2";
import AppLoading from "./common/app-loading";
import {
  CircularProgress,
  Button,
  Box,
} from "@mui/material";
import { AppHelper } from "../AppHelper";

export default function PageSaEssaySubmit() {
  const navigate = useNavigate();
  const oUser = AppHelper.userCacheGet();

  const [isLoading, setIsLoading] = useState(false);

  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [isClosing, setIsClosing] = React.useState(false);

  useEffect(() => {
    if (!oUser) {
      navigate("/login");
      return;
    }
  }, [oUser, navigate]);

  const handleButtonClick = async () => {
    setIsButtonLoading(true);
    try {
      var _user = AppHelper.userCacheGet();
      var _url = "api/essay/create/withVersion/async";
      const response = await fetch("/payload/essay.json");
      const data = await response.json();
      for (var i = 0; i < data.length; i++) {
        var recEssay = data[i];
        var _payload = {
          token: _user.token,
          imgs: [],
          essayId: recEssay.essayId,
          text: recEssay.text,
          topic: recEssay.topic,
          grade: recEssay.grade,
          addScore: 0,
          profileId: _user.profileId,
        };
        _payload.verScore = "v" + recEssay.version;
        _payload.verCorr = "v" + "2.0"; //versionCorr;
        var _res = await AppHelper.apiPost(_url, _payload);

        if (!_res.status) {
          alert("ERROR");
          return;
        }
      }
      alert("SUCCESS!");
    } catch (error) {
      alert("Error processing essay.json:");
    } finally {
      setIsButtonLoading(false);
    }
  };

  const mobileOpenClick = (arg) => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <AppTopBar2 mobileOpen={mobileOpen} mobileOpenClick={mobileOpenClick} />
      {isLoading ? (
        <AppLoading />
      ) : (
        <>
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: 3,
              width: "100%",
              marginTop: "50px",
            }}
          >
            <Box sx={{ mt: 2 }}>
              <Button
                sx={{
                  backgroundColor: "rgba(19,130,117,1)",
                  ":hover": { backgroundColor: "rgb(157, 188, 152)" },
                }}
                variant="contained"
                color="info"
                onClick={handleButtonClick}
                disabled={isButtonLoading}
              >
                {isButtonLoading ? <CircularProgress size={24} /> : "Submit"}
              </Button>
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
}
